import Accordion from '@alltrails/denali/components/Accordion';
import type { SeoLinkItem } from '@alltrails/types/SeoLinkItem';
import LinksColumn from '../LinksColumn';
import styles from './LinkAccordian.module.scss';

type LinkAccordianProps = {
  title: string | React.ReactNode;
  isOpen?: boolean;
  toggleIsOpen: () => void;
  links: SeoLinkItem[];
  seoTestAddTrailsToLocationLinks?: boolean;
  seoTestAddHikingTrailsToLocationLinks?: boolean;
};

const LinkAccordian = ({
  title,
  isOpen = false,
  toggleIsOpen,
  links,
  seoTestAddTrailsToLocationLinks,
  seoTestAddHikingTrailsToLocationLinks
}: LinkAccordianProps) => {
  return (
    <Accordion
      title={title}
      variant="minimal"
      buttonContainerClassName={styles.buttonContainer}
      externalControls={{
        isOpen,
        toggleIsOpen
      }}
    >
      <div className={styles.links}>
        <LinksColumn
          links={links}
          seoTestAddTrailsToLocationLinks={seoTestAddTrailsToLocationLinks}
          seoTestAddHikingTrailsToLocationLinks={seoTestAddHikingTrailsToLocationLinks}
        />
      </div>
    </Accordion>
  );
};

export default LinkAccordian;
